import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Landmark, Megaphone, Menu, X } from "lucide-react";
import { scrollToId } from "../config";

const LINKS = [
  { id: "profil", label: "Profil" },
  { id: "kerja-nyata", label: "Kerja Nyata" },
  { id: "dusun", label: "Dusun" },
  { id: "ronda", label: "24/7 Ronda" },
  { id: "suara", label: "Suara Warga" },
  { id: "agenda", label: "Agenda" },
  { id: "aspirasi", label: "Aspirasi" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <div className="mt-4 flex items-center justify-between rounded-2xl border border-line bg-bg/80 backdrop-blur-xl px-4 sm:px-5 py-3 shadow-[0_8px_30px_rgba(30,58,43,0.08)]">
          <button
            data-testid="nav-brand-logo"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
            className="flex items-center gap-2.5 text-left"
          >
            <span className="grid place-items-center w-9 h-9 rounded-full bg-forest text-bg">
              <Landmark size={17} strokeWidth={2.2} />
            </span>
            <span className="leading-tight">
              <span className="block font-serif font-bold text-sm sm:text-base">Mulyono M.H.</span>
              <span className="block font-mono text-[10px] uppercase tracking-[0.2em] text-soft">
                Kades Cianjay
              </span>
            </span>
          </button>

          <nav className="hidden lg:flex items-center gap-6">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-link-${l.id}`}
                onClick={() => go(l.id)}
                className="text-sm font-medium text-ink/80 hover:text-terra transition-colors"
              >
                {l.label}
              </button>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <button
              data-testid="nav-cta-aspirasi"
              onClick={() => go("aspirasi")}
              className="hidden sm:inline-flex items-center gap-2 rounded-full bg-terra px-5 py-2.5 text-sm font-semibold text-white transition-transform hover:-translate-y-0.5 hover:bg-terra/90"
            >
              <Megaphone size={15} /> Sampaikan Aspirasi
            </button>
            <button
              data-testid="nav-mobile-toggle"
              onClick={() => setOpen(!open)}
              className="lg:hidden grid place-items-center w-10 h-10 rounded-full border border-line"
              aria-label="Menu"
            >
              {open ? <X size={18} /> : <Menu size={18} />}
            </button>
          </div>
        </div>

        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ opacity: 0, y: -8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25 }}
              className="lg:hidden mt-2 rounded-2xl border border-line bg-bg/95 backdrop-blur-xl p-3 shadow-xl"
              data-testid="nav-mobile-menu"
            >
              {LINKS.map((l) => (
                <button
                  key={l.id}
                  data-testid={`nav-mobile-link-${l.id}`}
                  onClick={() => go(l.id)}
                  className="block w-full text-left px-4 py-3 rounded-xl text-sm font-medium hover:bg-badge transition-colors"
                >
                  {l.label}
                </button>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};
